export const authPalette = {
  // Reference colors from homeyhuts.com
  primary: '#FF6B35', // Orange-red for buttons
  primaryHover: '#E55A2B',
  primaryDark: '#FF2800',
  primaryDarkHover: '#D92200',
  logoRed: '#FF6B35',
  formBg: '#FFE9E5', // Light pink for form panel
  leftPanelBg: '#FFFFFF', // White for left panel
  textPrimary: '#2C2C2C', // Dark gray for headings
  textSecondary: '#666666', // Medium gray for body text
  borderLight: '#E0E0E0', // Light gray for borders
  white: '#FFFFFF',
  hoverBg: '#F5F5F5',
};

export const authTypography = {
  heroTitle: { fontWeight: 800 as const, lineHeight: 1.2, letterSpacing: 0 },
  heroSubtitle: { opacity: 0.9 },
  cardTitle: { fontWeight: 700 as const, color: '#3a3a3a' },
};

export const authSpacing = {
  cardPadding: { xs: 3, md: 4 } as const,
  cardRadius: { xs: 0, md: 3 } as const,
  cardShadow: { xs: 'none', md: '0 10px 40px rgba(0,0,0,0.1)' } as const,
  verticalGutter: { xs: 2, md: 4 } as const,
};

export const authButtons = {
  primary: {
    fontWeight: 500,
    textTransform: 'uppercase',
    fontSize: '14px',
    borderRadius: '8px',
  },
};
